import { gsap } from 'gsap';
import Swiper, { HashNavigation, Navigation, Thumbs } from 'swiper';
import 'swiper/swiper.scss';
import { pauseAllPlayers } from '@components/ui/vimeo-player/vimeo-player';

Swiper.use([HashNavigation, Navigation, Thumbs]);

const testimonialsThumbnails = new Swiper('.testimonials__carousel-thumbnails', {
  slidesPerView: 1.3,
  spaceBetween: 10,
  threshold: 11,
  breakpoints: {
    550: {
      slidesPerView: 2.3,
    },
    700: {
      slidesPerView: 4,
    },
  },
});

const testimonialsCarousel = new Swiper('.testimonials__carousel', {
  autoHeight: false,
  slidesPerView: 1,
  init: false,
  // loop: false, //keep looping false to allow data tracking
  hashNavigation: true,
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
  thumbs: {
    swiper: testimonialsThumbnails,
  },
});

// testimonialsCarousel.on('hashSet', () => {
//   gsap
//     .set(window, {
//       scrollTo: {
//         y: '#testimonials',
//         offsetY: -10,
//       },
//     });
// });
testimonialsCarousel.on('slideChange', () => pauseAllPlayers());
testimonialsCarousel.init();
